var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"webfoot"},[_vm._v("\n  © 2016-"+_vm._s(_vm.toyear)+" Take, Inc.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }